/**
 * Initial state
 * @type {Object}
 */
const state = {

}

/**
 * Getters
 * @type {Object}
 */
const getters = {

}

/**
 * Mutations
 * @type {Object}
 */
const mutations = {

}

/**
 * Actions
 * @type {Object}
 */
const actions = {

}

// Export module
export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/libraries/store/modules/users.js